
export default {
    getSelProjectId: (state) => state.selProjectId,
    getSelVesselId: (state) => state.selVesselId,
    getSelProjectVesselIds: (state) => state.selProjectVesselIds
}